// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_0d624b9a27--tooltip--Hs2ji"};